import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MouseEvent } from '@agm/core';
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { ClientesService } from '../../../services/Clientes.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertasModales } from '../../../helpers/alertasModales';
import { UploadFilesService } from '../../../services/upload-files.service';
import { Helper } from '../../../helpers/helper';
import { PadronService } from '../../../services/padron.service';
@Component({
  selector: 'app-editar',
  templateUrl: './editar.component.html',
  styles: []
})
export class EditarClienteComponent implements OnInit {
  tiempo = ['dia(s)', 'semana(s)', 'mes(es)', 'año(s)'];

  form: FormGroup;
  msgError: string;
  msgSuccess: string;
  rutas = [];
  loaded = false;
  // nivel de zoom de google maps
  zoom: number;
  loading = false;
  // posición inicial del centro para el mapa
  lat: number;
  lng: number;
  disabled = true;
  isEditingRef = false;
  valueChange = false;
  mask: any;
  imgCedula: File;
  urlImg: string;
  hasFoto = false;
  private foto;
  nombreDiferente = false;
  nombrePadron = '';
  apellidoPadron: any;
  negocioRequired = false;
  fotoCedula = 'assets/img/cedula.png';


  constructor(private route: Router,
    private _rutasService: RutasService,
    public alerts: AlertasModales,
    private params: ActivatedRoute,
    private uploadFileService: UploadFilesService,
    private helper: Helper,
    private empleadoService: EmpleadosServicio,
    private clienteService: ClientesService,
    private padron: PadronService) {
    this.cargarRutas();
    // Inicializar variables
    this.zoom = 8;
    this.lat = 18.6691759;
    this.lng = -71.2512628;
    this.setFormulario();

    this.urlImg = this.helper.urlImg + 'cedulas/';
  }

  ngOnInit() {
    this.initFormulario();
    const datosNegocio = this.form.get('datosNegocio');
    datosNegocio.get('negocio_nombre').valueChanges
    .subscribe(res => {
      if (res) {
        for (const key of Object.keys(datosNegocio.value)) {
          // tslint:disable-next-line:max-line-length
          if (key === 'negocio_salario' || key === 'negocio_tiempo' || key === 'negocio_actividad' || key === 'negocio_telefono' || key === 'negocio_direccion') {
            datosNegocio.get(key).setValidators(Validators.required);
            datosNegocio.get(key).updateValueAndValidity();
            this.negocioRequired = true;
          }
        }
      } else {
        this.negocioRequired = false;
        for (const key of Object.keys(datosNegocio.value)) {
          datosNegocio.get(key).clearValidators();
        }
      }
    });
  }

  // Agregar un marker en el mapa de google y asigna las coordenadas lat/lng del cliente
  mapClicked($event: MouseEvent): void {
    this.form.get('lat').setValue($event.coords.lat);
    this.form.get('lng').setValue($event.coords.lng);
  }

  // Cargar todas las rutas
  private cargarRutas(): void {
    this._rutasService.cargarTodasLasRutas()
    .subscribe( result => { this.rutas = result.rutas; });
  }

  private initFormulario(): void {
    // Inicializar el formulario de cliente
    this.form = new FormGroup({
      'limite_credito': new FormControl(''),
      'ID_CLIENTE': new FormControl('', Validators.required),
      'fallecido': new FormControl(false),
      'puede_renovar': new FormControl(false),
      'identificacion': new FormControl('', Validators.required),
      'foto_perfil': new FormControl(''),
      'fecha_nacimiento': new FormControl('', Validators.required),
      'estado_civil': new FormControl(''),
      'cedula': new FormControl('', Validators.required),
      'nombre': new FormControl('', Validators.required),
      'apellido': new FormControl('', Validators.required),
      'apodo': new FormControl(''),
      'dependientes': new FormControl(''),
      'vivienda_propia': new FormControl(''),
      'vivienda_alquiler': new FormControl(''),
      'vivienda_tiempo': new FormControl(''),
      'sexo': new FormControl(''),
      'correo': new FormControl(''),
      'telefono': new FormControl('', Validators.required),
      'celular': new FormControl(''),
      'ID_RUTA': new FormControl('', Validators.required),
      'ID_REFERIDO': new FormControl(''),
      'direccion': new FormControl('', Validators.required),
      'lat': new FormControl(''),
      'lng': new FormControl(''),
      'ID_EMPLEADO': new FormControl(''),
      'clienteReferencia': new FormGroup({
        'ID_CLIENTE_REFERENCIA': new FormControl('0'),
        'nombre': new FormControl(''),
        'parentesco': new FormControl(''),
        'telefono': new FormControl(''),
        'index': new FormControl(''),
      }),
      'referenciasPersonales': new FormArray([]),
      'nombreReferido': new FormControl({value: '', disabled: true}),
      'datosNegocio': new FormGroup({
        'negocio_propio': new FormControl(''),
        'negocio_alquiler': new FormControl(''),
        'negocio_rnc': new FormControl(''),
        'negocio_nombre': new FormControl(''),
        'negocio_local': new FormControl(''),
        'negocio_telefono': new FormControl(''),
        'negocio_direccion': new FormControl(''),
        'negocio_actividad': new FormControl(''),
        'negocio_salario': new FormControl(''),
        'negocio_tiempo': new FormControl(''),
        'negocio_frecuencia_salario': new FormControl('')
      })
    });
  }

  private setFormulario(): void {
    this.params.params
    .subscribe(params => {
      if (!isNaN(params.id)) {

        this.clienteService.obtenerClienteParaEditar(params.id)
        .subscribe((res: any) => {
          let fecha_nacimiento = res.fecha_nacimiento.split('-');
          fecha_nacimiento = {
            year: parseFloat(fecha_nacimiento[0]),
            month: parseFloat(fecha_nacimiento[1]),
            day: parseFloat(fecha_nacimiento[2])
          };

          this.hasFoto = res.foto_perfil ? true : false;
          this.foto = res.foto_perfil ? res.foto_perfil : '';
          if (this.foto) {
            this.fotoCedula = `${this.helper.baseUrl}/uploads/clientes/${res.compania}/${res.cedula}/cedulas/${this.foto}`;
          }

          this.form.get('limite_credito').setValue(res.limite_credito);
          this.form.get('ID_CLIENTE').setValue(res.ID);
          this.form.get('foto_perfil').setValue((res.foto_perfil ? res.foto_perfil : ''));
          this.form.get('sexo').setValue(String(res.sexo));
          this.form.get('estado_civil').setValue(res.estado_civil);
          this.form.get('fecha_nacimiento').setValue(fecha_nacimiento);
          this.form.get('fallecido').setValue(res.fallecido);
          this.form.get('puede_renovar').setValue(res.puede_renovar);
          this.form.get('identificacion').setValue(res.identificacion);
          this.form.get('cedula').setValue(res.cedula);
          this.form.get('nombre').setValue(res.nombre);
          this.form.get('apellido').setValue(res.apellido);
          this.form.get('apodo').setValue(res.apodo);
          this.form.get('correo').setValue(res.correo);
          this.form.get('telefono').setValue(res.telefono);
          this.form.get('celular').setValue(res.celular);
          this.form.get('ID_RUTA').setValue(res.ID_RUTA);
          this.form.get('direccion').setValue(res.direccion);
          this.form.get('dependientes').setValue(res.dependientes);
          this.form.get('vivienda_propia').setValue(res.vivienda_propia);
          this.form.get('vivienda_alquiler').setValue(res.vivienda_alquiler);
          this.form.get('vivienda_tiempo').setValue(res.vivienda_tiempo);
          this.form.get('lat').setValue(res.lat);
          this.form.get('lng').setValue(res.lng);
          this.form.get('datosNegocio').get('negocio_propio').setValue(res.negocio_propio);
          this.form.get('datosNegocio').get('negocio_alquiler').setValue(res.negocio_alquiler);
          this.form.get('datosNegocio').get('negocio_rnc').setValue(res.negocio_rnc);
          this.form.get('datosNegocio').get('negocio_nombre').setValue(res.negocio_nombre);
          this.form.get('datosNegocio').get('negocio_local').setValue(res.negocio_local);
          this.form.get('datosNegocio').get('negocio_telefono').setValue(res.negocio_telefono);
          this.form.get('datosNegocio').get('negocio_direccion').setValue(res.negocio_direccion);
          this.form.get('datosNegocio').get('negocio_actividad').setValue(res.negocio_actividad);
          this.form.get('datosNegocio').get('negocio_salario').setValue(res.negocio_salario);
          this.form.get('datosNegocio').get('negocio_tiempo').setValue(res.negocio_tiempo);
          this.form.get('datosNegocio').get('negocio_frecuencia_salario').setValue(res.negocio_frecuencia_salario);
          this.form.get('ID_EMPLEADO').setValue(this.empleadoService.datosEmpleado.ID_EMPLEADO);
          this.form.get('nombreReferido').setValue(res.nombreReferido);
          this.form.get('ID_REFERIDO').setValue(res.ID_REFERIDO);
          this.padron.getCedula(res.cedula).subscribe((cedula: any) => {
            if (cedula) {
              if (String(res.nombre + ' ' + res.apellido) !== String(cedula.data.nombre + ' ' + cedula.data.apellidos)) {
                this.nombreDiferente = true;
                this.nombrePadron = cedula.data.nombre;
                this.apellidoPadron =  cedula.data.apellidos;

              }
            }
          });
          if (res.identificacion === 1) {

            this.form.get('cedula').setValidators([Validators.required, Validators.minLength(13)]);
            this.mask = {mask: '000-0000000-0', len: 13};
          } else {
            this.form.get('cedula').setValidators(Validators.required);
            this.mask = '';
          }
          this.form.get('cedula').markAsTouched();
          for (const referenciaPersonal of res.referenciasPersonales) {
            (<FormArray>this.form.get('referenciasPersonales')).push(
              new FormControl(referenciaPersonal)
            );
          }
          setTimeout(() => {
            this.form.updateValueAndValidity();
            this.loaded = true;
          }, 200);
        });
      } else {

        this.route.navigate(['/404']);
      }
    }, () => {
      this.route.navigate(['/404']);
    });
  }

  editarCliente() {
    if (this.form.valid) {
      this.loading = true;
      if (this.form.get('foto_perfil').value !== this.foto) {

        this.uploadFileService.uploadCedula(this.imgCedula, this.form.get('cedula').value)
        .then(fileName => {
          this.form.get('foto_perfil').setValue(fileName);
          const data = this.form.value;
          data.fecha_nacimiento = data.fecha_nacimiento ? `${data.fecha_nacimiento.year}-${data.fecha_nacimiento.month}-${data.fecha_nacimiento.day}` : '';
          this.clienteService.editarCliente(data).subscribe(res => {
            this.loading = false;
            if (res) {
              this.alerts.edicionClienteModalJquery(this.route, this.form.get('ID_CLIENTE').value,
              'CLIENTE ACTUALIZADO EXITOSAMENTE', 'VER CLIENTE', 'green', 'modern', 'btn-green');
            }
          }, err => {
            this.loading = false;
            if (err) {
              this.alerts.validacionesModalJquery('Error de validación', err.error, 'red', 'modern');
            }
          });
        }).catch(() => this.loading = false);
      } else {

        this.loading = true;
        this.form.get('foto_perfil').setValue(this.foto);
        const data = this.form.value;
        data.fecha_nacimiento = data.fecha_nacimiento ? `${data.fecha_nacimiento.year}-${data.fecha_nacimiento.month}-${data.fecha_nacimiento.day}` : '';
        this.clienteService.editarCliente(data).subscribe(res => {
          this.loading = false;
          if (res) {
            this.alerts.edicionClienteModalJquery(this.route, this.form.get('ID_CLIENTE').value,
            'CLIENTE ACTUALIZADO EXITOSAMENTE', 'VER CLIENTE', 'green', 'modern', 'btn-green');
          }
        }, err => {
          this.loading = false;
          if (err) {
            this.alerts.validacionesModalJquery('Error de validación', err.error, 'red', 'modern');
          }
        });
      }
    }
  }

  // Agregar un elemente del object cliente.referenciasPersonales
  agregarClienteReferencia() {
    const clienteReferencia = this.form.get('clienteReferencia');
    if (clienteReferencia.get('nombre').value
        && clienteReferencia.get('telefono').value
        && clienteReferencia.get('parentesco').value) {
        const cliente = {
          nombre: this.form.get('nombre').value,
          apellido: this.form.get('apellido').value,
          ID_CLIENTE: this.form.get('ID_CLIENTE').value,
          ID_RUTA: this.form.get('ID_RUTA').value
        };
      this.clienteService
      .agregarReferenciaPersonal(clienteReferencia.value, cliente, this.empleadoService.datosEmpleado.ID_EMPLEADO)
      .subscribe(res => {
        this.form.get('clienteReferencia.ID_CLIENTE_REFERENCIA').setValue(res);

        (<FormArray>this.form.get('referenciasPersonales')).push(
          new FormControl(this.form.get('clienteReferencia').value)
        );
        this.form.get('clienteReferencia').reset({'parentesco': ''});
      });
    }
  }

  // Remueve un elemente del object cliente.referenciasPersonales
  removerRefPersonalElemento(i) {

    const html =
    `¿Desea eliminar esta referencia?`;
    this.alerts.confirmNgbModal(html, 'Eliminar Referencia')
    .then(resp => {
      if (resp && resp === 'si') {
    const cliente = {
      nombre: this.form.get('nombre').value,
      apellido: this.form.get('apellido').value,
      ID_CLIENTE: this.form.get('ID_CLIENTE').value,
      ID_RUTA: this.form.get('ID_RUTA').value
    };
    this.clienteService
    .removerReferenciaPersonal(
      this.form.get('referenciasPersonales').value[i].ID_CLIENTE_REFERENCIA,
      cliente,
      this.empleadoService.datosEmpleado.ID_EMPLEADO
    )
    .subscribe(() => {
      (<FormArray>this.form.get('referenciasPersonales')).removeAt(i);
    });
  }
  });
  }

  // Buscar referido por
  buscar() {
    this.alerts.busquedaAvanzadaClientesNgbModal().then((res: any) => {
      if (res) {
        this.form.get('nombreReferido').setValue(res.nombre + ' ' + res.apellido);
        this.form.get('ID_REFERIDO').setValue(res.id);
      }
    });
  }

  eliminarReferidoPor() {
    this.form.get('nombreReferido').reset();
    this.form.get('ID_REFERIDO').reset();
  }

  editarReferencia(referencia, i) {
    this.isEditingRef = true;
    this.form.get('clienteReferencia.ID_CLIENTE_REFERENCIA').setValue(referencia.ID_CLIENTE_REFERENCIA);
    this.form.get('clienteReferencia.nombre').setValue(referencia.nombre);
    this.form.get('clienteReferencia.telefono').setValue(referencia.telefono);
    this.form.get('clienteReferencia.parentesco').setValue(referencia.parentesco);
    this.form.get('clienteReferencia.index').setValue(i);
  }

  btnEditarReferencia() {
    const i = this.form.get('clienteReferencia.index').value;
    const clienteReferencia = this.form.get('clienteReferencia');
    if (clienteReferencia.get('nombre').value
        && clienteReferencia.get('telefono').value
        && clienteReferencia.get('parentesco').value) {
      const cliente = {
        nombre: this.form.get('nombre').value,
        apellido: this.form.get('apellido').value,
        ID_CLIENTE: this.form.get('ID_CLIENTE').value,
        ID_RUTA: this.form.get('ID_RUTA').value
      };
      this.clienteService
      .editarReferenciaPersonal(clienteReferencia.value, cliente, this.empleadoService.datosEmpleado.ID_EMPLEADO)
      .subscribe(() => {
        (<FormArray>this.form.get('referenciasPersonales')).removeAt(i);
        (<FormArray>this.form.get('referenciasPersonales')).push(
          new FormControl(clienteReferencia.value)
        );
        clienteReferencia.reset({'parentesco': ''});
        this.isEditingRef = false;
      }, err =>  {
        console.log(err);
      });
    }
  }
  identificacionChange() {
    if (this.form.get('identificacion').value === '1') {

      this.form.get('cedula').setValidators([Validators.required, Validators.minLength(13)]);
      this.mask = {mask: '000-0000000-0', len: 13};
    } else {
      this.form.get('cedula').setValidators(Validators.required);
      this.mask = '';
    }
    this.form.get('cedula').markAsTouched();
    this.form.get('cedula').updateValueAndValidity();
  }
  cedulaChange(event) {
    this.form.get('cedula').setValue(event.target.value);
    this.form.get('cedula').clearValidators();
    if (this.form.get('identificacion').value === '1') {

      this.form.get('cedula').setValidators([Validators.required, Validators.minLength(13)]);
    } else {
      this.form.get('cedula').setValidators(Validators.required);
    }
    this.form.get('cedula').markAsTouched();
    this.form.get('cedula').updateValueAndValidity();
  }

  loadFile(file: any) {
    // Validar que exista una img
    if (file.files.length > 0 && file.files[0].type.startsWith('image')) {
      this.imgCedula = file.files[0];

      // Cargar un preview de la img seleccionada
      const reader = new FileReader();
      reader.onload = (e: any) => {

        $('#preview').attr('src', e.target.result);
      };
      // tslint:disable-next-line:no-unused-expression
      reader.readAsDataURL(this.imgCedula);
      this.form.get('foto_perfil').setValue(this.imgCedula.name);
    } else {
      $('#preview').attr('src', './assets/img/cedula.png');
    }
  }

  actualizarNombrePadronElectoral() {
    if (this.nombreDiferente) {

      const data = {
        nombre: this.nombrePadron,
        apellido: this.apellidoPadron,
        ID_CLIENTE: this.form.get('ID_CLIENTE').value,
        ID_RUTA: this.form.get('ID_RUTA').value
       };
       this.clienteService.actualizarNombrePadronElectoral(data).subscribe(res => {
         if (res) {
          this.nombreDiferente = false;
          this.form.get('nombre').setValue(this.nombrePadron);
          this.form.get('apellido').setValue(this.apellidoPadron);
          this.alerts.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
         }
       });
    }
  }

  seMurio() {
    const html = `¿Deseas actualizar este cliente?`;
    this.alerts.confirmNgbModal(html, 'Cliente fallecido').then(resp => {
      if (resp && resp === 'si') {
        const data = {
          ID_CLIENTE: this.form.get('ID_CLIENTE').value,
          fallecido: this.form.get('fallecido').value,
        };
        this.clienteService.fallecio(data)
        .subscribe();
      } else {
        this.form.get('fallecido').setValue(!this.form.get('fallecido').value);
      }
    });
  }

  onPuedeRenovar() {
    const html = `¿Deseas actualizar este cliente?`;
    this.alerts.confirmNgbModal(html, 'CLIENTE ACTUALIZADO').then(resp => {
      if (resp && resp === 'si') {
        const data = {
          ID_CLIENTE: this.form.get('ID_CLIENTE').value,
          puede_renovar: this.form.get('puede_renovar').value,
        };
        this.clienteService.puede_renovar(data).subscribe();
      } else {
        this.form.get('puede_renovar').setValue(!this.form.get('puede_renovar').value);
      }
    });
  }

  tiempoSelectChange(value, forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');

    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    if (tiempo.value) {

      const valueSplited = (tiempo.value as string).split(' ');
      tiempo.setValue(
        (typeof parseFloat(valueSplited[0]) == 'number' ? valueSplited[0] : 1) + ` ${value}`
      );

    } else {
      tiempo.setValue(`1 ${value}`);
    }

  }

  tiempoInputChange(value, forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');
    
    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    if (tiempo.value) {

      const valueSplited = (tiempo.value as string).split(' ');
      tiempo.setValue(
        value + ` ${valueSplited.length == 2 ? valueSplited[1] : valueSplited[0]}`
      );

    } else {
      tiempo.setValue(value + ` ${this.tiempo[2]}`);
    }
  }

  tiempoSelectValue(forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');
    
    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }  

    if (tiempo.value) {
      const valueSplited = (tiempo.value as string).split(' ');
      return valueSplited[1];
    }

    return this.tiempo[0];
  }

  inputValue(forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');
    
    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }
    
    if (tiempo.value) {
      const valueSplited = (tiempo.value as string).split(' ');
      return typeof parseFloat(valueSplited[0]) === 'number' ? valueSplited[0] : ''
    }

    return '';
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/clientes/editar/editar.component.ts